// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Aktivität#Aktivitäten',
    Activities_Text: '1#{0} Aktivität#{0} Aktivitäten',
    Activity: 'Aktivität',
    Activity_Billing: 'Rechnungswesen',
    Activity_Cost: 'Aktivitätskosten',
    Activity_CostVariance: 'Kostenspielraum',
    Activity_HoursLeft: 'links',
    Activity_InternalCost: 'Tatsächliche Kosten',
    Activity_Profit: 'Profit',
    Add_Task: 'Aufgabe hinzufügen',
    Apply_Text: 'Übernehmen',
    Board_CreateTaskInProjectPlaceholder: 'In Projekt erstellen',
    Board_ShowMore: 'Weitere anzeigen',
    Budget_Text: 'Budget',
    By_Text: 'bis',
    Create: 'Erstellen',
    CreateNewItem: 'Hier eingeben, um neues Projekt oder neue Aktivität zu erstellen ...',
    CreateProject_Tooltip: 'Neues Projekt erstellen',
    CriticalPath_Text: 'Essenziellen Pfad',
    CustomField_No: 'Nein',
    CustomField_Yes: 'Ja',
    DayPluralFormat: '1#Tag#Tage',
    Default_Text: 'Standard',
    Delete_Text: 'Löschen',
    DeleteEntityConfirmation: '<b>einschließlich aller Zeitprotokolle, Nachrichten und angehängten Dateien</b> {0}. Die Aktion kann nicht rückgängig gemacht werden!',
    DeletePermanently: 'Endgültig löschen',
    DeleteVerb: '1#wird endgültig gelöscht#werden endgültig gelöscht',
    Dependency_AddMore_Text: 'mehr Abhängigkeiten hinzufügen',
    Dependency_Cancel: 'Abbrechen',
    Dependency_Choose: 'Aktivität auswählen oder ein Schlagwort eingeben ... ',
    Dependency_days: 'Tage',
    Dependency_DelayWarningExample: 'Beispiel: -34, 42',
    Dependency_DelayWarningText: 'Nummern von -1000 bis 1000 eingeben',
    Dependency_DependencyCycle: 'Die Abhängigkeit kann nicht erstellt werden, da die ausgewählte Aktivität einen Zirkelbezug erzeugt.',
    Dependency_DependencyType_Text: 'Abhängigkeitstyp',
    Dependency_DependsOn_Text: 'Abhängig von',
    Dependency_FinishToStart_Minus1: 'Aktivität beginnt am Tag, bevor {0} beendet ist',
    Dependency_FinishToStart_Minus1_Pattern: 'Aktivität beginnt <b>am Tag, bevor</b> \"{0}\" beendet ist',
    Dependency_FinishToStart_Minus2: 'Aktivität beginnt {1}, bevor {0} beendet ist',
    Dependency_FinishToStart_Minus2_Pattern: 'Aktivität beginnt <b>{1}, bevor</b> \"{0}\" beendet ist',
    Dependency_FinishToStart_Plus0: 'Aktivität beginnt am Tag, an dem {0} beendet ist',
    Dependency_FinishToStart_Plus0_Pattern: 'Aktivität beginnt <b>am Tag, an dem</b> \"{0}\" beendet ist',
    Dependency_FinishToStart_Plus1: 'Aktivität beginnt am Tag, nachdem {0} beendet ist',
    Dependency_FinishToStart_Plus1_Pattern: 'Aktivität beginnt <b>am Tag, nachdem</b> \"{0}\" beendet ist',
    Dependency_FinishToStart_Plus2: 'Aktivität beginnt {1}, nachdem {0} beendet ist',
    Dependency_FinishToStart_Plus2_Pattern: 'Aktivität beginnt <b>{1}, nachdem</b> \"{0}\" beendet ist',
    Dependency_FinishWhenStarted_Text: 'Aktivität beendet bei Start von \"{0}\"',
    Dependency_FinishWhenStarted_Title: 'Anfang zu Ende',
    Dependency_Lag_Text: 'Lag',
    Dependency_ParentChildRelationship: 'Die Abhängigkeit kann nicht erstellt werden, da eine der Aktivitäten einer der anderen Aktivitäten untergeordnet ist (Unteraktivität).',
    Dependency_Reason: 'Grund',
    Dependency_Remove_Text: 'Entfernen',
    Dependency_RemoveSingleDependency_Text: 'Entfernen',
    Dependency_Save: 'Speichern',
    Dependency_SelectDependsOn_Text: 'Auswählen ist abhängig von',
    Dependency_StartsWhenFinished_Text: 'Aktivität beginnt bei Ende von \"{0}\"',
    Dependency_StartsWhenFinished_Title: 'Ende zu Anfang',
    Dependency_StartsWhenStarted_Text: 'Aktivität beginnt bei Beginn von \"{0}\"',
    Dependency_StartsWhenStarted_Title: 'Anfang zu Anfang',
    Dependency_StartToFinish_Minus1: 'Aktivität ist beendet am Tag, bevor {0} beginnt',
    Dependency_StartToFinish_Minus1_Pattern: 'Aktivität ist beendet <b>am Tag, bevor</b> \"{0}\" beginnt',
    Dependency_StartToFinish_Minus2: 'Aktivität ist beendet {1}, bevor {0} beginnt',
    Dependency_StartToFinish_Minus2_Pattern: 'Aktivität ist beendet <b>{1}, bevor</b> \"{0}\" beginnt',
    Dependency_StartToFinish_Plus0: 'Aktivität ist beendet am Tag, an dem {0} beginnt',
    Dependency_StartToFinish_Plus0_Pattern: 'Aktivität ist beendet <b>am Tag, an dem</b> \"{0}\" beginnt',
    Dependency_StartToFinish_Plus1: 'Aktivität ist beendet am Tag, nachdem {0} beginnt',
    Dependency_StartToFinish_Plus1_Pattern: 'Aktivität ist beendet <b>am Tag, nachdem</b> \"{0}\" beginnt',
    Dependency_StartToFinish_Plus2: 'Aktivität ist beendet {1}, nachdem {0} beginnt',
    Dependency_StartToFinish_Plus2_Pattern: 'Aktivität ist beendet <b>{1}, nachdem</b> \"{0}\" beginnt',
    Dependency_StartToStart_Minus1: 'Aktivität beginnt am Tag, bevor {0} beginnt',
    Dependency_StartToStart_Minus1_Pattern: 'Aktivität beginnt <b>am Tag, bevor</b> \"{0}\" beginnt',
    Dependency_StartToStart_Minus2: 'Aktivität beginnt {1}, bevor {0} beginnt',
    Dependency_StartToStart_Minus2_Pattern: 'Aktivität beginnt <b>{1}, bevor</b> \"{0}\" beginnt',
    Dependency_StartToStart_Plus0: 'Aktivität beginnt am Tag, an dem {0} beginnt',
    Dependency_StartToStart_Plus0_Pattern: 'Aktivität beginnt <b>am Tag, an dem</b> \"{0}\" beginnt',
    Dependency_StartToStart_Plus1: 'Aktivität beginnt am Tag, nachdem {0} beginnt',
    Dependency_StartToStart_Plus1_Pattern: 'Aktivität beginnt <b>am Tag, nachdem</b> \"{0}\" beginnt',
    Dependency_StartToStart_Plus2: 'Aktivität beginnt {1}, nachdem {0} beginnt',
    Dependency_StartToStart_Plus2_Pattern: 'Aktivität beginnt <b>{1}, nachdem</b> \"{0}\" beginnt',
    Dependency_Warning_Text: 'Der Vorgang konnte nicht abgeschlossen werden. ',
    Edit_Text: 'Bearbeiten',
    EnterProjectName: 'Projektnamen eingeben',
    EnterTaskName: 'Aufgabennamen eingeben',
    EnterViewName_Text: 'Anzeigename eingeben',
    Error_DragAndDrop_BreakingHierarchy: 'Eine Aktivität kann nicht die übergeordnete Aktivität seiner eigenen übergeordneten Aktivität sein.',
    Error_DragAndDrop_CycleDependencies: 'Dadurch entsteht ein Zirkelbezug (z.B. Aufgabe A hängt von Aufgabe B ab, Aufgabe B hängt aber wiederum von Aufgabe A ab)',
    Error_DragAndDrop_DifferentProjects: 'Betreffende Aktivitäten gehören zu verschiedenen Projekten.',
    Error_PresetNotFound: 'Die gewählte Ansicht wurde gelöscht oder wird nicht mehr geteilt. Aktualisieren Sie die Seite, um fortzufahren.',
    Export_Activities_Text: 'Aktivitäten als CSV exportieren',
    Export_Import_Text: 'Export & Import',
    Export_Projects_Text: 'Projekte als CSV exportieren',
    From: 'von',
    Hide_Text: 'Verbergen',
    Hours_Short_Text: 'Std',
    Import_CSV_Text: 'Import aus CSV',
    Import_MSProject_Text: 'Import aus MS Project',
    Import_Text: 'Import',
    Learn_More_Text: 'Weitere Informationen',
    Loading_Text: 'Lade ...',
    My_Text: 'Ich',
    MyPresetName_Text: 'Mein',
    NewProject: 'Neues Projekt',
    NewProjectBasedOn: 'Neues Projekt basierend auf {0}',
    NewTask: 'Neue Aufgabe',
    No_Templates_Text: 'Keine Vorlagen gefunden.',
    NoSavedViews_Text: 'Keine gespeicherten Anzeigen.',
    Of: 'von',
    Project: 'Projekt',
    Project_ActualBudgetProfitability: 'Tatsächliche Budget-Rentabilität',
    Project_BudgetedCost: 'Gesamtprojektbudget',
    Project_CostVariance: 'Kostenspielraum',
    Project_EstimatedBudgetProfitability: 'Erwartete Budget-Rentabilität',
    Project_Expenses: 'Ausgaben',
    Project_InternalCost: 'Tatsächliche Kosten',
    Project_ProjectBilling: 'Projektkosten',
    Project_ProjectProfit: 'Projektprofit',
    Project_ProjectProfitability: 'Ertragskraft',
    Projects: '1#Projekt#Projekte',
    Projects_Text: '1#{0} Projekt#{0} Projekte',
    Rename_Text: 'Umbenennen',
    Restore_Text: 'Wiederherstellen',
    Save_Text: 'Speichern',
    SaveAs_Text: 'Speichern als',
    Share_Text: 'Teilen',
    Show_Text: 'Anzeigen',
    SortBy_Text: 'Sortiere nach',
    SubActivities: '1#Unteraktivität#Unteraktivitäten',
    Templates_Popup_Title: 'Basierend auf Vorlage:',
    TimerText: '1#{0} Sekunde#{0} Sekunden',
    Tools_Menu_Text: 'Werkzeuge',
    Tooltip_DefaultPresetIcon: 'Gespeicherte Anzeigen auswählen oder verwalten',
    Tooltip_RevertToDefaultPreset: 'Zur Standardansicht gehen',
    Tooltip_SaveDefaultPreset: 'Aktuelles Layout und Filter als Anzeige speichern',
    Unshare_Text: 'Nicht teilen',
    WBSNumber_Text: 'WBS',
};
